import { redisGetHandler } from "../utils/redis";

export default (axios, config) => ({
  // Где вызывается: сервер.
  async getBrands(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/brands/getBrands",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getBrand(Redis, code, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/brands/getBrand?code=${code}`,
      reset,
    );
  },
});
